module.exports = __webpack_public_path__ + "static/media/icon-settings.812b4a86.svg";